export const ITUNES_URL =
  'https://itunes.apple.com/us/app/filtru-interactive-coffee/id1150921819?ls=1&amp;mt=8';
export const guideURL = (slug: string) =>
  `https://guides.filtru.coffee/${slug}`;
